import { Subscription } from '~/api/data/subscription/types';

const subscriptionEnded = (subscription?: Subscription) => {
  return subscription?.canceledAt || subscription?.status === 'CANCELED' || subscription?.status === 'FINISHED';
};

export default subscriptionEnded;
